import React, { useState, useEffect } from "react"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js"
import { useSelector } from "react-redux"
import PatientSidebarStats from "./PatientSidebarStats"
import Graphs from "./GraphComponent"
import PerformancePdfDownload from "./PerformancePdfDownload"

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
)

const Performance = ({ mode }) => {
  const { patient } = useSelector((state) => state.patient)
  const [filterSelected, setFilterSelected] = useState("correctness")
  const path = mode === "off" ? "nonVR" : "vr"
  const profileDetails = patient?.data[0]
  const [selectedExercise, setSelectedExercise] = useState(() => {
    if (!profileDetails) return null

    const exerciseNames = Object.keys(profileDetails.exercises[path])
      .filter(
        (item) =>
          profileDetails.exercises[path]?.[item]?.scoreHistory?.length > 0
      )
      .map((exerciseName) => {
        return { label: exerciseName, id: exerciseName }
      })

    return exerciseNames[0]
  })
  const game = selectedExercise?.label
  const CurrentExerciseDetails = profileDetails?.exercises[path]?.[game]
  const [showPerformancePdfDownload, setShowPerformancePdfDownload] =
    useState(false)

  useEffect(() => {
    if (profileDetails) {
      const exerciseNames = Object.keys(profileDetails.exercises[path])
        .filter(
          (item) =>
            profileDetails.exercises[path]?.[item]?.scoreHistory?.length > 0
        )
        .map((exerciseName) => {
          return { label: exerciseName, id: exerciseName }
        })
      setSelectedExercise(exerciseNames[0])
    }
  }, [mode, profileDetails, path])

  const handleSelectedExercise = (e, newValue) => {
    setSelectedExercise(newValue)
  }

  return (
    <>
      <div className="md:py-8 md:px-10 md:bg-[--pure-white] rounded-2xl flex flex-col [@media(min-width:1800px)]:flex-row gap-10 max-w-full">
        <Graphs
          game={game}
          handleSelectedExercise={handleSelectedExercise}
          filterSelected={filterSelected}
          setFilterSelected={setFilterSelected}
          path={path}
        />
        <PatientSidebarStats
          game={game}
          profileDetails={profileDetails}
          CurrentExerciseDetails={CurrentExerciseDetails}
          setShowPerformancePdfDownload={setShowPerformancePdfDownload}
          path={path}
        />
      </div>
      {showPerformancePdfDownload ? (
        <PerformancePdfDownload
          game={game}
          handleSelectedExercise={handleSelectedExercise}
          profileDetails={profileDetails}
          CurrentExerciseDetails={CurrentExerciseDetails}
          setShowPerformancePdfDownload={setShowPerformancePdfDownload}
          path={path}
        />
      ) : null}
    </>
  )
}

export default Performance
